import React, { useState } from 'react'

import style from './Style.scss'

type Props = {
  isMultiline: boolean
}
export const OpenTypeField = ({ isMultiline }: Props) => {
  const openTypeValue = isMultiline ? 'Long answer text' : 'Short answer text'
  const [userAnswer, setUserAnswer] = useState<string>('')

  return isMultiline ? (
    <textarea
      value={userAnswer}
      placeholder={openTypeValue}
      onChange={newInput => setUserAnswer(newInput.target.value)}
      className={style.textarea}
    />
  ) : (
    <input
      value={userAnswer}
      placeholder={openTypeValue}
      onChange={newInput => setUserAnswer(newInput.target.value)}
      className={style.input}
    />
  )
}
